import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import Button from '@panneau/element-button';
import Buttons from '@panneau/element-buttons';
import FormStatus from '@panneau/element-form-status';

var propTypes = {
  action: PropTypes.string,
  method: PropTypes.string,
  status: PropTypes$1.formStatus,
  children: PropTypes.node,
  actions: PropTypes.node,
  buttons: PropTypes$1.buttons,
  generalError: PropTypes.string,
  buttonSize: PropTypes.string,
  submitButtonLabel: PropTypes$1.label,
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  onCancelHref: PropTypes.string,
  withoutActions: PropTypes.bool,
  withoutStatus: PropTypes.bool,
  withoutErrors: PropTypes.bool,
  withoutButtonGroup: PropTypes.bool,
  canSave: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  buttonsClassName: PropTypes.string,
  cancelClassName: PropTypes.string
};
var defaultProps = {
  action: null,
  method: 'POST',
  status: null,
  children: null,
  actions: null,
  buttons: null,
  generalError: null,
  buttonSize: 'lg',
  submitButtonLabel: null,
  onSubmit: null,
  onCancel: null,
  onCancelHref: null,
  withoutActions: false,
  withoutStatus: false,
  withoutErrors: false,
  withoutButtonGroup: false,
  canSave: true,
  disabled: false,
  className: null,
  buttonsClassName: null,
  cancelClassName: null
};
var Form = function Form(_ref) {
  var action = _ref.action,
    method = _ref.method,
    status = _ref.status,
    children = _ref.children,
    actions = _ref.actions,
    buttons = _ref.buttons,
    generalError = _ref.generalError,
    buttonSize = _ref.buttonSize,
    withoutButtonGroup = _ref.withoutButtonGroup,
    submitButtonLabel = _ref.submitButtonLabel,
    onSubmit = _ref.onSubmit,
    onCancel = _ref.onCancel,
    onCancelHref = _ref.onCancelHref,
    withoutActions = _ref.withoutActions,
    withoutStatus = _ref.withoutStatus,
    withoutErrors = _ref.withoutErrors,
    canSave = _ref.canSave,
    disabled = _ref.disabled,
    className = _ref.className,
    buttonsClassName = _ref.buttonsClassName,
    cancelClassName = _ref.cancelClassName;
  return /*#__PURE__*/React.createElement("form", {
    action: action,
    method: method,
    onSubmit: onSubmit,
    disabled: disabled,
    className: className
  }, children, !withoutErrors && generalError !== null && !disabled ? /*#__PURE__*/React.createElement("p", {
    className: "text-danger mt-4"
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "2vB7U4",
    defaultMessage: [{
      "type": 0,
      "value": "An error occured and we could not save this item successfully."
    }]
  })) : null, (!withoutStatus && status !== null || !withoutActions) && !disabled ? /*#__PURE__*/React.createElement("div", {
    className: "mt-4 d-flex align-items-center"
  }, !withoutStatus && status !== null ? /*#__PURE__*/React.createElement(FormStatus, {
    status: status
  }) : null, !withoutActions ? /*#__PURE__*/React.createElement("div", {
    className: classNames(['ms-auto d-flex align-items-center', {
      'btn-group': !withoutButtonGroup
    }])
  }, actions, onCancel !== null || onCancelHref !== null ? /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: onCancel,
    href: onCancelHref,
    theme: "secondary",
    size: buttonSize,
    disabled: status === 'loading',
    className: classNames([_defineProperty({
      'me-2': withoutButtonGroup
    }, cancelClassName, cancelClassName !== null)])
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "PyxZY2",
    defaultMessage: [{
      "type": 0,
      "value": "Cancel"
    }]
  })) : null, buttons !== null ? /*#__PURE__*/React.createElement(Buttons, {
    buttons: buttons,
    className: classNames(_defineProperty({}, buttonsClassName, buttonsClassName !== null))
  }) : /*#__PURE__*/React.createElement(Button, {
    type: "submit",
    theme: "primary",
    size: buttonSize,
    label: submitButtonLabel || /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "R1HYj0",
      defaultMessage: [{
        "type": 0,
        "value": "Save"
      }]
    })
    // icon={status === 'loading' ? 'loading' : 'check'}
    // iconPosition="right"
    ,
    disabled: !canSave || status === 'loading' && generalError === null,
    outline: !canSave,
    className: classNames({
      'ms-auto': actions === null
    })
  })) : null) : null);
};
Form.propTypes = propTypes;
Form.defaultProps = defaultProps;

export { Form as default };
